import React, { useEffect, useState } from "react";
import Navbar from "../../../navbar/navbar";
import Footer from "../../../footer/footer";
import Scroll from "./../../../scrolltotop";
import Header from "../../projectoverview/overviewheader";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";

import Img1 from "../../../../assets/Chruch Webp/churchconferencehall/-Church-view-2-24-06-2024.webp";
import Img2 from "../../../../assets/Chruch Webp/churchconferencehall/02.webp";
import Img3 from "../../../../assets/Chruch Webp/churchconferencehall/ABC 1.webp";
import Img4 from "../../../../assets/Chruch Webp/churchconferencehall/Church-view-1-24-06-2024.webp";
import Img5 from "../../../../assets/Chruch Webp/churchconferencehall/Church-view-4-24-06-2024.webp";
import Img6 from "../../../../assets/Chruch Webp/churchconferencehall/Samson Associates_Yercaudu Church Interior_06-12-2024 (1).webp";
import Img7 from "../../../../assets/Chruch Webp/churchconferencehall/WhatsApp Image 2024-12-05 at 17.46.20.webp";


const rawImages = [
  Img1, Img2, Img3, Img4, Img5, Img6, Img7
];

const images = rawImages.map((src, index) => ({
  src,
  alt: `Image ${index + 1}`,
  title: `Image ${index + 1} of 7`,
  // description: `This is image number ${index + 1}`, // Optional
}));

const ProjectImageGrid = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openIndex, setOpenIndex] = useState(-1);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <div>
      <Scroll />
      <Navbar />
      <Header />

      <div style={{ padding: "20px", marginTop: "50px" }}>
        <div
          style={{
            display: isMobile ? "flex" : "grid",
            flexDirection: isMobile ? "column" : "unset",
            gridTemplateColumns: isMobile ? "unset" : "repeat(auto-fit, minmax(300px, 1fr))",
            gridAutoRows: isMobile ? "unset" : "250px",
            gap: "10px",
            gridAutoFlow: "dense",
          }}
        >
          {rawImages.map((image, index) => (
            <div key={index} style={{ overflow: "hidden", borderRadius: "10px" }}>
              <img
                src={image}
                alt={`Project ${index + 1}`}
                style={{
                  width: "100%",
                  height: isMobile ? "auto" : "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                  transition: "transform 0.3s ease-in-out",
                  cursor: "pointer",
                }}
                onClick={() => setOpenIndex(index)}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </div>
          ))}
        </div>
      </div>

      <Lightbox
        open={openIndex >= 0}
        index={openIndex}
        close={() => setOpenIndex(-1)}
        slides={images}
        plugins={[Thumbnails, Captions]} // <-- 👈 Add plugins here
      />
{/* Inline style override for caption container */}
<style>
        {`
          .yarl__slide_captions_container {
            background: transparent !important;
          }

           .yarl__container {
      background-color:rgba(0, 0, 0, 0.9)  !important; /* Dark grey */
    }
        `}
      </style>

      <Footer />
    </div>
  );
};

export default ProjectImageGrid;